import { CodeBlockWrapper } from './chunk-N3PTFZV7.mjs';
import { Card, CardContent } from '@mui/material';
import { jsx } from 'react/jsx-runtime';

var PostContent = (props) => {
  return /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(CardContent, { children: /* @__PURE__ */ jsx(CodeBlockWrapper, { children: props.children }) }) });
};

export { PostContent };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-XMMX5OWE.mjs.map